import React from 'react';
import { useTranslation } from 'react-i18next';

import { TooltipContentType } from 'component/Incentive/Badge/__config/TooltipContentType';

export interface TextProps {
    type: TooltipContentType;
    customClass?: string;
    link?: string;
}

const Text = ({ type, customClass = '', link }: TextProps) => {
    const { t } = useTranslation();
    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        window.open(
            link,
            t(`TRANS-link-wording-${type}`),
            'width=810,height=720'
        );
    };
    return (
        <>
            <div className={customClass}>
                <div
                    dangerouslySetInnerHTML={{
                        __html: t(`TRANS-tooltip-${type}`),
                    }}
                />
                {!!link && (
                    <>
                        <a href={link} onClick={handleClick}>
                            {t(`TRANS-link-wording-${type}`)}
                        </a>
                    </>
                )}
            </div>
        </>
    );
};

export default Text;
